import type { DocumentNode } from "graphql";

import { createTeamInAllocation } from "src/allocation/graphql/team.graphql";
import {
  updateGroupName as teamPageUpdateGroupName,
  updateTeamAttributes as teamPageUpdateTeamAttributes,
} from "src/pages/TeamDetailPage/team.graphql";
import {
  createTeam,
  updateGroupName,
} from "src/queries/mutations/group.graphql";
import { updateTeamAttributes } from "src/queries/mutations/updateTeamAttributes.graphql";

import {
  createTeamWithOption,
  updateGroupAttributesWithOption,
  updateGroupNameWithOption,
} from "./designOptionGraphql";

const OVERLAY_TWINS = new Map<DocumentNode, DocumentNode>([
  [updateGroupName, updateGroupNameWithOption],
  [teamPageUpdateGroupName, updateGroupNameWithOption],
  [createTeam, createTeamWithOption],
  [createTeamInAllocation, createTeamWithOption],
  [updateTeamAttributes, updateGroupAttributesWithOption],
  [teamPageUpdateTeamAttributes, updateGroupAttributesWithOption],
]);

/** Live → *WithOption twin. C5 stays: twins remain, pairing does not leak. */
export const overlayTwinFor = (
  liveMutation: DocumentNode
): DocumentNode | undefined => OVERLAY_TWINS.get(liveMutation);
